import React from 'react';
import Icon, { IIcon } from './Icon';

const ArrowLeftIcon: React.FC<IIcon> = props => (
  <Icon width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
    <path d="M26.6667 16H5.33334" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path
      d="M12.4444 23.1113L5.33333 16.0002L12.4444 8.8891"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default ArrowLeftIcon;
